export function btoa(str) {
  return window.btoa(str);
}

export function atob(str) {
  return window.atob(str);
}

export function ua() {
  return window.navigator.userAgent;
}

export function locationHref() {
  return window.location.href;
}

export function getHash() {
  return window.location.hash;
}

export function decodeURIComponent(str) {
  return window.decodeURIComponent(str);
}

export function encodeURIComponent(str) {
  return window.encodeURIComponent(str);
}

export function unescape(str) {
  return window.unescape(str);
}

export function changeTitle(str) {
  document.title = str;
}

export function redirect(href, delay = 0) {
  setTimeout(()=>{
    location.href = href;
  }, delay);
}

export function replace(href, delay = 0) {
  setTimeout(()=>{
    location.replace(href);
  }, delay);
}

export function locationPathname() {
  return window.location.pathname;
}

export function locationProtocal() {
  return window.location.protocol;
}

export function locationOrigin() {
  return window.location.origin;
}

export function scrollToTop() {
  return window.scrollTo(0, 0);
}

/** 针对我们后端的decodeURIComponent */
function xdecodeURIComponent(str){
    str = str.replace(/\+/g, '%20');
    return decodeURIComponent(str);
}
